import {
  AppBar,
  AppBarClasses,
  LocalesMenuButton,
  ToggleThemeButton,
  useAuthProvider,
} from 'react-admin';
import type { AppBarProps } from 'react-admin';
import { Box, Typography } from '@mui/material';
// import { darkTheme, lightTheme } from './themes';

const CustomAppBar = ({ classes, userMenu, ...props }: AppBarProps) => {
  const authProvider = useAuthProvider();

  return (
    <AppBar userMenu={userMenu ?? !!authProvider} {...props}>
      <Typography
        variant="h6"
        color="inherit"
        className={AppBarClasses.title}
        id="react-admin-title"
      />
      <Box component="span" sx={{ flex: 2 }} />
      <LocalesMenuButton
        languages={[
          { locale: 'en', name: 'English' },
          { locale: 'fr', name: 'Français' },
        ]}
      />
      {/*<ToggleThemeButton lightTheme={lightTheme} darkTheme={darkTheme} />*/}
    </AppBar>
  );
};

export default CustomAppBar;
